export function isObject(data: any): data is { [key: string]: any } {
  return typeof data === "object" && data !== null && !Array.isArray(data);
}

export function transformStringToArray(value: unknown): unknown | unknown[] {
  try {
    if (typeof value === "string") {
      return JSON.parse(value);
    }
    if (Array.isArray(value)) {
      return value;
    }
    return [];
  } catch {
    return [];
  }
}

export function transformStringToArrayOfDates(
  value: unknown
): unknown | Date[] {
  try {
    if (typeof value === "string") {
      const parsed_json = JSON.parse(value);

      if (Array.isArray(parsed_json)) {
        return parsed_json.map(parseToDate);
      }
    }
    if (Array.isArray(value)) {
      return value.map(parseToDate);
    }
    return [];
  } catch {
    return [];
  }
}

function parseToDate(value: unknown): Date {
  if (typeof value === "string") {
    const date = new Date(value);
    if (!Number.isNaN(date.getTime())) {
      return date;
    } else {
      throw new Error(`Date format is invalid: ${value}`);
    }
  } else if (value instanceof Date) {
    return value;
  } else {
    throw new Error(`Expected string or Date object, got ${typeof value})`);
  }
}
